<template>
  <div class="w-100 h-100 d-flex flex-column position-relative scrollbar" ref="ScrollRef" style="padding:16px 8px; overflow-y: scroll;">
    <div class="fw-bold" style="padding:8px;">
      データ入稿
    </div>

    <div class="row p-2 position-relative" :class="{'feature-ui':this.$store.state.tutorial.isShowPreview && this.$store.state.tutorial.previewStep == 1}">
      <div class="row text-start m-0">
        <p class="m-0 p-0">デザイン（PNG）<img src="@/assets/acrypro/question-icon.svg" style="width:20px;height:20px;margin-left:-5px;margin-top:-5px;" class="cursor-pointer" @click="clickPngHelp()" /></p>
      </div>
      <label class="uploadlabel position-relative"
        ><input
          type="file"
          ref="design"
          accept=".png"
          @change="uploadDesign"
        />
        <div v-if="!isUploadDesign">
          <svg class="fill-color" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
          <path d="M22.4167 13.0002C22.4167 7.52565 17.9836 3.0835 12.5104 3.0835C7.02583 3.0835 2.58335 7.52663 2.58335 13.0002C2.58335 18.4737 7.02584 22.9168 12.5104 22.9168C17.9836 22.9168 22.4167 18.4747 22.4167 13.0002ZM21.3334 13.0002C21.3334 17.8805 17.3803 21.8335 12.5 21.8335C7.61971 21.8335 3.66669 17.8805 3.66669 13.0002C3.66669 8.11986 7.61971 4.16683 12.5 4.16683C17.3803 4.16683 21.3334 8.11985 21.3334 13.0002Z"/>
          <path d="M7.5 13.8332L17.5 13.8332L17.5 12.1665L7.5 12.1665L7.5 13.8332Z"/>
          <path d="M13.3334 18L13.3334 8L11.6667 8L11.6667 18L13.3334 18Z"/>
          </svg>
          <span class="fw-bold">アップロード</span>
        </div>
        <div v-else>
          <span class="text-main-color">{{this.$store.state.eventCreateData.designData.fileName}}</span>
        </div>
      </label>
    </div>

    <div class="row p-2 position-relative" :class="{'feature-ui':this.$store.state.tutorial.isShowPreview && this.$store.state.tutorial.previewStep == 2}">
      <div class="row text-start m-0">
        <p class="m-0 p-0">カットライン（SVG）<img src="@/assets/acrypro/question-icon.svg" style="width:20px;height:20px;margin-left:-5px;margin-top:-5px;" class="cursor-pointer" @click="clickSvgHelp()" /></p>
      </div>
      <label class="uploadlabel position-relative"
        ><input
          type="file"
          ref="cutline"
          accept=".svg"
          @change="uploadCutline"
        />
        <div v-if="!isUploadCutline">
          <svg class="fill-color" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
          <path d="M22.4167 13.0002C22.4167 7.52565 17.9836 3.0835 12.5104 3.0835C7.02583 3.0835 2.58335 7.52663 2.58335 13.0002C2.58335 18.4737 7.02584 22.9168 12.5104 22.9168C17.9836 22.9168 22.4167 18.4747 22.4167 13.0002ZM21.3334 13.0002C21.3334 17.8805 17.3803 21.8335 12.5 21.8335C7.61971 21.8335 3.66669 17.8805 3.66669 13.0002C3.66669 8.11986 7.61971 4.16683 12.5 4.16683C17.3803 4.16683 21.3334 8.11985 21.3334 13.0002Z"/>
          <path d="M7.5 13.8332L17.5 13.8332L17.5 12.1665L7.5 12.1665L7.5 13.8332Z"/>
          <path d="M13.3334 18L13.3334 8L11.6667 8L11.6667 18L13.3334 18Z"/>
          </svg>
          <span class="fw-bold">アップロード</span>
        </div>
        <div v-else>
          <span class="text-main-color">{{this.$store.state.eventCreateData.cutlineData.fileName}}</span>
        </div>
      </label>
    </div>

    <hr class="mt-1 mb-0">

    <!-- <div class="fw-bold" style="padding:8px;">
      編集禁止領域
    </div>

    <div class="row p-2 position-relative">
      <div class="row text-start m-0">
        <p class="m-0 p-0">編集禁止領域（PNG）<img src="@/assets/acrypro/question-icon.svg" style="width:20px;height:20px;margin-left:-5px;margin-top:-5px;" class="cursor-pointer" @click="clickNonEditableHelp()" /></p>
        <p class="m-0 p-0" style="font-size: 12px; color: #BC6665;">※禁止領域は設定しなくても問題ありません</p>
      </div>
      <label class="uploadlabel position-relative"
        ><input
          type="file"
          ref="nonEditable"
          accept=".png"
          @change="uploadNonEditable"
        />
        <div v-if="!isUploadNonEditable">
          <svg class="fill-color" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
          <path d="M22.4167 13.0002C22.4167 7.52565 17.9836 3.0835 12.5104 3.0835C7.02583 3.0835 2.58335 7.52663 2.58335 13.0002C2.58335 18.4737 7.02584 22.9168 12.5104 22.9168C17.9836 22.9168 22.4167 18.4747 22.4167 13.0002ZM21.3334 13.0002C21.3334 17.8805 17.3803 21.8335 12.5 21.8335C7.61971 21.8335 3.66669 17.8805 3.66669 13.0002C3.66669 8.11986 7.61971 4.16683 12.5 4.16683C17.3803 4.16683 21.3334 8.11985 21.3334 13.0002Z"/>
          <path d="M7.5 13.8332L17.5 13.8332L17.5 12.1665L7.5 12.1665L7.5 13.8332Z"/>
          <path d="M13.3334 18L13.3334 8L11.6667 8L11.6667 18L13.3334 18Z"/>
          </svg>
          <span class="fw-bold">アップロード</span>
        </div>
        <div v-else>
          <span class="text-main-color">{{this.$store.state.eventCreateData.nonEditableData.fileName}}</span>
        </div>
      </label>
    </div>

    <hr class="mt-1 mb-0"> -->

    <div class="mt-auto w-100 my-3 position-relative" :class="{'disable-ui':!(isUploadDesign&&isUploadCutline)}">
      <div>
        <button @click="clickConfirm" class="acry-btn-cartin btn-size my-1" >確定</button>
      </div>
    </div>

  </div>
</template>

<script>
import {
  ProductId,
  GetCanvasSize,
  // CenterViewState,
  RightViewState,
} from "@/js/Const.js";
import { CreateImageElement, CombineSVGFrame } from "@/js/CommonFunc.js";
import { OffScreen } from "@/js/OffScreen.js";
import { FileKit } from "@/js/FileKit.js";

export default {
  name: "RightMenuEventImageUpload_Ap",
  props: {},
  data: function () {
    return {
      designFileName:"デザインデータ",
      cutlineFileName:"カットラインデータ",
      nonEditableFileNmae:"編集禁止領域データ",
      discountText: "",
      isFirstTutorial:false,
    };
  },
  watch: {
  },
  computed: {
    isUploadDesign() {
      return this.$store.state.eventCreateData.designData != null;
    },
    isUploadCutline() {
      return this.$store.state.eventCreateData.cutlineData != null;
    },
    isUploadNonEditable() {
      return this.$store.state.eventCreateData.nonEditableData != null;
    },
  },
  async created() {
    this.$store.commit("showRightMenu");
    // this.$store.commit("showLoading");
    // this.$store.commit("hideLoading");

  },
  components: {},
  methods: {
    getCanvasSize(){
      let productId = 0;
      switch(this.$store.state.eventCreateData.selectSize){
        case "S": productId = ProductId.S_SVG; break;
        case "M": productId = ProductId.M_SVG; break;
        case "L": productId = ProductId.L_SVG; break;
      }

      let canvasSize = GetCanvasSize(productId);
      return {
        "width":canvasSize.canvasScreenSizeWidth+"px",
        "height":canvasSize.canvasScreenSizeHeight+"px",
        };
    },
    async uploadDesign() {
      let file = this.$refs.design.files[0];
      this.designFileName = file.name;

      // アクリルのサイズにトリミング
      let productId = 0;
      switch(this.$store.state.eventCreateData.selectSize){
        case "S": productId = ProductId.S_SVG; break;
        case "M": productId = ProductId.M_SVG; break;
        case "L": productId = ProductId.L_SVG; break;
      }

      let canvasSize = GetCanvasSize(productId);
      let offScreen = new OffScreen(canvasSize.width, canvasSize.height);
      let image = await CreateImageElement(URL.createObjectURL(file));
      offScreen.drawImage(image, 0, 0, image.width, image.height);
      const blob = await new Promise((resolve) => {
        offScreen.toBlob(function (blob) {
          resolve(blob);
        });
      });

      file = new File([blob], file.name, { type: "image/png" });
      this.$store.commit("setEventCreateDesignData", new FileKit(file));
    },
    async uploadCutline() {
      let file = this.$refs.cutline.files[0];

      // フレームパスを合成
      let productId = 0;
      switch(this.$store.state.eventCreateData.selectSize){
        case "S": productId = ProductId.S_SVG; break;
        case "M": productId = ProductId.M_SVG; break;
        case "L": productId = ProductId.L_SVG; break;
      }
      //file = await aaa(file);
      await CombineSVGFrame(file, productId);

      this.$store.commit("setEventCreateCutlineData", new FileKit(file));
      this.$store.commit("setEventCreateCutlineImageURL", URL.createObjectURL(file));

      let canvasSize = GetCanvasSize(productId);
      const imageWidth = canvasSize.width;
      const imageHeight = canvasSize.height;
      let offScreen = new OffScreen(imageWidth, imageHeight);

      let image = await CreateImageElement(this.$store.state.eventCreateData.cutlineImageURL);
      offScreen.drawImage(image, 0, 0, imageWidth, imageHeight);
      offScreen.replacement("#000000")

      const blob = await new Promise((resolve) => {
        offScreen.toBlob(function (blob) {
          resolve(blob);
        });
      });

      this.$store.commit("setEventCreateCutlineImageURL", URL.createObjectURL(blob));
    },
    async uploadNonEditable() {
      let file = this.$refs.nonEditable.files[0];
      this.nonEditableFileName = file.name;

      // アクリルのサイズにトリミング
      let productId = 0;
      switch(this.$store.state.eventCreateData.selectSize){
        case "S": productId = ProductId.S_SVG; break;
        case "M": productId = ProductId.M_SVG; break;
        case "L": productId = ProductId.L_SVG; break;
      }

      let canvasSize = GetCanvasSize(productId);
      let offScreen = new OffScreen(canvasSize.width, canvasSize.height);
      let image = await CreateImageElement(URL.createObjectURL(file));
      offScreen.drawImage(image, 0, 0, image.width, image.height);
      offScreen.replacement('#EB7A7A');
      const blob = await new Promise((resolve) => {
        offScreen.toBlob(function (blob) {
          resolve(blob);
        });
      });

      file = new File([blob], file.name, { type: "image/png" });
      this.$store.commit("setEventCreateNonEditableData", new FileKit(file));
    },

    async clickConfirm() {
      this.$store.commit("setRightViewState", RightViewState.Cart);
      this.$store.commit("setPreviousCenterViewState");
      if (!(this.isUploadDesign && this.isUploadCutline)) {
        this.$store.commit("showMessage", "アップロードされていないデータがあります");
        return;
      }

      // プレビュー用の画像を生成する
      let productId = 0;
      switch(this.$store.state.eventCreateData.selectSize){
        case "S": productId = ProductId.S_SVG; break;
        case "M": productId = ProductId.M_SVG; break;
        case "L": productId = ProductId.L_SVG; break;
      }

      let canvasSize = GetCanvasSize(productId);
      const imageWidth = canvasSize.width;
      const imageHeight = canvasSize.height;
      let offScreen = new OffScreen(imageWidth, imageHeight);

      let image1 = await CreateImageElement(this.$store.state.eventCreateData.designData.fileURL);
      offScreen.drawImage(image1, 0, 0, imageWidth, imageHeight);
      let image2 = await CreateImageElement(this.$store.state.eventCreateData.frameCutlineImageURL);
      offScreen.drawImage(image2, 0, 0, imageWidth, imageHeight);

      // 禁止領域がある場合は追加
      if( this.$store.state.eventCreateData.nonEditableData ){
        let offScreen2 = new OffScreen(imageWidth, imageHeight);
        let image3 = await CreateImageElement(this.$store.state.eventCreateData.nonEditableData.fileURL);
        offScreen2.drawImage(image3, 0, 0, image3.width, image3.height);
        offScreen2.setOpacity(0.5);
        const blob = await new Promise((resolve) => {
          offScreen2.toBlob(function (blob) {
            resolve(blob);
          });
        });
        image3 = await CreateImageElement(URL.createObjectURL(blob));
        offScreen.drawImage(image3, 0, 0, imageWidth, imageHeight);
      }

      const blob = await new Promise((resolve) => {
        offScreen.toBlob(function (blob) {
          resolve(blob);
        });
      });

      // プレビュー画像をFILE化
      const file = new File([blob], "preview.png", { type: "image/png" })
      this.$store.commit("setEventCreatePreviewData", new FileKit(file));

      // 表示を戻す
      // if( this.$store.state.eventCreateData.isEdit ){
      //   // 編集
      //   this.$store.commit("setCenterViewState", CenterViewState.EventCreateDesign);
      //   this.$store.commit("setRightViewState", RightViewState.Cart);
      // }else{
      //   // 新規作成
      //   this.$store.commit("setCenterViewState", CenterViewState.EventCreateDesign);
      //   this.$store.commit("setRightViewState", RightViewState.Cart);
      // }


      this.$store.commit("setPreviousCenterViewState");
      this.$store.commit("setRightViewState", RightViewState.Cart);

    },

    clickPngHelp(){
      this.$store.commit("setPreviewTutorialScroll", this.$refs.ScrollRef.scrollTop);
      this.$store.commit("showPreviewTutorial", 1);
    },
    clickSvgHelp(){
      this.$store.commit("setPreviewTutorialScroll", this.$refs.ScrollRef.scrollTop);
      this.$store.commit("showPreviewTutorial", 2);
    },
    clickNonEditableHelp(){
      this.$store.commit("setPreviewTutorialScroll", this.$refs.ScrollRef.scrollTop);
      this.$store.commit("showPreviewTutorial", 3);
    },


  },
};
</script>

<style scoped lang="scss">
.uploadlabel {
  margin: 8px;
  padding: 8px;
  cursor: pointer;
  font-size: 15px;
  width: 267px;
  height: 40px;
  color: $primary-main-color;
  border: 2px solid $primary-main-color;
  border-radius: 100px;
  background: $background-white-color;
}

.fill-color {
  fill: $primary-main-color;
  position: absolute;
  left: 51px;
  top: 6px;
}

input[type="file"] {
  display: none;
}

.btn-size{
  width: 100%;
  height: 40px;
  font-weight: bold;
}
.form{
  height: 48px;

}

.forminput {
  width: 100%;
  border: 1px solid $status-success-color;
}

.disable-ui {
  opacity: 0.5;
}

.feature-ui{
  z-index: 3;
  pointer-events: none;
  background: white;
}

.scrollbar {
    -ms-overflow-style: none;
    scrollbar-width: none;
}

.scrollbar::-webkit-scrollbar {
    display: none;
}
</style>
